import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-54be1376")
const _hoisted_1 = { class: "_loadPrompt" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "_header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " ... ")
], -1)
const _hoisted_3 = { class: "centralSpinner" }
const _hoisted_4 = {
  key: 1,
  class: "lobby"
}
const _hoisted_5 = { class: "_header" }
const _hoisted_6 = { class: "_headerBack" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Store ", -1)
const _hoisted_8 = {
  key: 0,
  class: "_patchMark"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "Patching", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "We'll be right back", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "latest" }, "Our latest", -1)
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "titleWrapper" }
const _hoisted_15 = { class: "description" }
const _hoisted_16 = { class: "meta" }
const _hoisted_17 = {
  key: 0,
  class: "rating"
}
const _hoisted_18 = {
  key: 0,
  class: "count"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "features" }
const _hoisted_21 = { class: "shopfront _card" }
const _hoisted_22 = { class: "meta" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Secure paypal checkout. ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Infinite replays. ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Guests play free.")
const _hoisted_29 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "button" }
const _hoisted_32 = {
  key: 1,
  class: "_b"
}
const _hoisted_33 = { class: "_card" }
const _hoisted_34 = {
  key: 0,
  class: "attributions"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h4", null, "Attributions", -1)
const _hoisted_36 = { class: "index num" }
const _hoisted_37 = { class: "index" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "_footer _card" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Advisory"),
  /*#__PURE__*/_createElementVNode("p", null, "gochase.me utilises PayPal for its shopfront. To ensure that transactions are fulfilled, please ensure and maintain a consistent internet connection when passing through the checkout window. By clicking the PayPal button, a window will be opened which facilitates the transaction. As outlined in our privacy statement, we do not collect any banking details. ")
], -1)
const _hoisted_40 = {
  key: 3,
  class: "_footer _card"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h4", null, "Patching?", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, " Don't worry - the game will return. We're just making some small alterations that should take next to no time at all. ETA is roughly 15-30 minutes. ", -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LazyImage = _resolveComponent("LazyImage")!
  const _component_PayPalButton = _resolveComponent("PayPalButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.storeLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_LoadSpinner, { text: "Please wait" })
          ]),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_MovingIcon, {
              name: "loader_spinner",
              autoplay: true,
              loop: true
            })
          ])
        ], 64))
      : (!_ctx.storeLoading && (_ctx.purchaseRequired || _ctx.game.patching))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_IconButton, {
                  icon: "back",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app/'}))),
                  white: true
                })
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", {
              class: _normalizeClass({_card:true,patching:_ctx.game.patching})
            }, [
              (_ctx.game.patching)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.game && _ctx.game.patching)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_LazyImage, {
                class: "displayImage _imageFade",
                src: _ctx.game.image
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["src"]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.game.title), 1)
                ]),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.game.description), 1),
                _createElementVNode("p", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass({difficulty:true,[`_${_ctx.difficulties[_ctx.game.difficulty]}`]:true})
                  }, null, 2),
                  _createTextVNode(" - " + _toDisplayString(_ctx.game.minutes) + " minutes ", 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.rating)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_MovingIcon, {
                          name: Math.min(Math.max(0,_ctx.rating.value),1)>0?'star_filled':'star',
                          hex: Math.min(Math.max(0,_ctx.rating.value),1)>0?'#000000':'#a0a0a0',
                          type: "svg"
                        }, null, 8, ["name", "hex"]),
                        _createVNode(_component_MovingIcon, {
                          name: Math.min(Math.max(0,_ctx.rating.value-1),1)>0?'star_filled':'star',
                          hex: Math.min(Math.max(0,_ctx.rating.value-1),1)>0?'#000000':'#a0a0a0',
                          type: "svg"
                        }, null, 8, ["name", "hex"]),
                        _createVNode(_component_MovingIcon, {
                          name: Math.min(Math.max(0,_ctx.rating.value-2),1)>0?'star_filled':'star',
                          hex: Math.min(Math.max(0,_ctx.rating.value-2),1)>0?'#000000':'#a0a0a0',
                          type: "svg"
                        }, null, 8, ["name", "hex"]),
                        _createVNode(_component_MovingIcon, {
                          name: Math.min(Math.max(0,_ctx.rating.value-3),1)>0?'star_filled':'star',
                          hex: Math.min(Math.max(0,_ctx.rating.value-3),1)>0?'#000000':'#a0a0a0',
                          type: "svg"
                        }, null, 8, ["name", "hex"]),
                        _createVNode(_component_MovingIcon, {
                          name: Math.min(Math.max(0,_ctx.rating.value-4),1)>0?'star_filled':'star',
                          hex: Math.min(Math.max(0,_ctx.rating.value-4),1)>0?'#000000':'#a0a0a0',
                          type: "svg"
                        }, null, 8, ["name", "hex"]),
                        (_ctx.rating.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " (" + _toDisplayString(_ctx.rating.number) + ") ", 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_MovingIcon, {
                          name: "loader_spinner",
                          autoplay: true,
                          loop: true
                        })
                      ])),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_MovingIcon, { name: "maps" })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_MovingIcon, { name: "web" })
                    ])
                  ])
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
    (!_ctx.storeLoading && (_ctx.purchaseRequired || !_ctx.game.patching))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.game.free?`Free!`:`$${_ctx.game.price} USD`), 1),
              (!_ctx.game.free)
                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _hoisted_29))
                : (_openBlock(), _createElementBlock("p", _hoisted_30, "Normally " + _toDisplayString(`$${_ctx.game.price}` || "$4.98") + " USD, this game is free for a limited time - Get in quick and have fun!", 1))
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_ctx.$store.state.Auth.user.signedOut)
                ? (_openBlock(), _createBlock(_component_IconButton, {
                    key: 0,
                    colored: true,
                    hex: "#FFFFFF",
                    icon: "user",
                    type: "svg",
                    text: _ctx.game.free?`Login to host`:`Login to purchase`,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/account'})))
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.Auth.user.signedOut)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                : (_openBlock(), _createBlock(_component_PayPalButton, {
                    key: 2,
                    game: _ctx.game,
                    onPurchased: _ctx.checkPurchased,
                    description: `${_ctx.game.title} - ${_ctx.game.description}`
                  }, null, 8, ["game", "onPurchased", "description"]))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_ctx.game.attributions && _ctx.game.attributions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("table", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.attributions, (a, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        (a.resource)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("td", _hoisted_36, _toDisplayString(index) + ".", 1),
                              _createElementVNode("td", _hoisted_37, _toDisplayString(a.resource) + ": " + _toDisplayString(a.author) + ". ", 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  target: "_blank",
                                  href: a.license
                                }, "License", 8, _hoisted_38)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_39
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.game.patching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_43))
      : _createCommentVNode("", true)
  ], 64))
}